module.exports = __webpack_public_path__ + "static/media/wake.e133ed07.png";